import React from "react"
import { graphql, useStaticQuery, navigate } from "gatsby"
import styled from "styled-components"
import WPLink from "components/shared/WPLink"
import Button from "components/shared/Button"
import { media } from "utils/Media"
import MenuItem from "./MenuItem"

const NavWrap = styled.nav`
  display: flex;
  align-items: center;
  z-index: 1;

  ul {
    padding: 0;
    margin: 0;
    display: none;
    list-style: none;
    
    @media ${media.nav} {
      display: block;
    }
    
    &.buttons {
      display: flex;
    }
    
    li:not(.book-tickets) {
      display: inline-block;
      
      a, span {
        cursor: pointer;
        display: block;
        color: ${props => props.theme.colors.primary};
        padding: 1rem 1rem;
        text-transform: uppercase;
        font-size: .95rem;
        
        @media ${media.xxl} {
          font-size: ${props => props.theme.font.size.base};
          /* padding: .5rem 1rem; */
        }
        
      }
      
      a > span {
        padding: 0;
      }
      
      li {
        display: block;
      }
      
      &:hover {
        > a, > a span, > span {
          text-decoration: none;
          color: ${props => props.theme.colors.secondary};
        }
        
        .sub-menu {
          visibility: visible;
          opacity: 1;
        }
      }
    }
    
    .book-tickets {
      margin: 0 .5rem; 
      a {
        padding: .75rem 2rem;
        border-radius: 5px;
        font-family: ${props => props.theme.font.family.bold};
      }
    }
  }
`

export default function Nav({currentPath}) {

  const data = useStaticQuery(graphql`
    query {
      allWpMenu(filter: {locations: {eq: PRIMARY}}, limit: 1000) {
        edges {
          node {
            menuItems {
              nodes {
                url
                target
                label
                parentDatabaseId
                acfMenu {
                  image {
                    altText
                    sourceUrl
                    localFile {
                      childImageSharp {
                        gatsbyImageData(width: 356, quality: 95, placeholder: NONE, layout: CONSTRAINED)
                      }
                    }
                  }
                }
                childItems {
                  nodes {
                    url
                    target
                    label
                    acfMenu {
                      image {
                        altText
                        sourceUrl
                        localFile {
                          childImageSharp {
                            gatsbyImageData(width: 356, quality: 95, placeholder: NONE, layout: CONSTRAINED)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      allWp {
        edges {
          node {
            options {
              acfOptions {
                bookTicketsUrl {
                  url
                  title
                  target
                }
              }
            }
          }
        }
      }
    }
  `)

  const { bookTicketsUrl } = data.allWp.edges[0].node.options.acfOptions
  const { menuItems } = data.allWpMenu.edges[0].node

  const scrollToEmail = (e) => {
    e.preventDefault()
    const el = document.getElementById('newsletter-signup')
    if (!el) {
      navigate("/#newsletter-signup")
    }
  }

  const mainMenu = menuItems.nodes.map((node, i) => {
    return node.parentDatabaseId === 0 ? <MenuItem item={node} key={node.databaseId} currentPath={currentPath} /> : null
  })

  return(
    <NavWrap>
      <ul>
        {mainMenu}
      </ul>
      <ul className="buttons">
        <li className="book-tickets d-none d-md-inline">
          <Button as="a" href="/#newsletter-signup" onClick={scrollToEmail} color="transparentPrimary"><span className="d-none d-lg-inline">Email</span> Sign Up</Button>
        </li>
        {bookTicketsUrl !== null && 
          <li className="book-tickets">
            <WPLink url={bookTicketsUrl.url} target={bookTicketsUrl.target} button color="secondary">
              {bookTicketsUrl.title}
            </WPLink>
          </li>
        }
      </ul>
    </NavWrap>
  )  
}